import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { lineString } from '~/prix/types/presets/geo'
import { roadSource } from '../road/road.data'

export const routingGraphEdgeObject = z.object({
  key: z.string(),
  sourceRoadKey: z.string(),
  source: roadSource,
  sourceNodeKey: z.string(),
  targetNodeKey: z.string(),
  sourceLongitude: z.number(),
  sourceLatitude: z.number(),
  targetLongitude: z.number(),
  targetLatitude: z.number(),
  municipalityId: z.number().int(),
  name: z.string().nullish(),
  lengthMeters: z.number(),
  cost: z.number(),
  reverseCost: z.number(),
  minLongitude: z.number(),
  minLatitude: z.number(),
  maxLongitude: z.number(),
  maxLatitude: z.number(),
  path: lineString(),
  surface: z.string().nullish(),
  roadClass: z.string().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
})

export type RoutingGraphEdgeType = z.infer<typeof routingGraphEdgeObject>
